{
  "version": 1,
  "asset_id": "487e3bbc-e786-4201-af1a-465e36c18ebb",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/487e3bbc-e786-4201-af1a-465e36c18ebb/zakelijke-verhuizing-kantoorinventaris.jpeg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/487e3bbc-e786-4201-af1a-465e36c18ebb/zakelijke-verhuizing-kantoorinventaris.jpeg",
  "original_filename": "zakelijke-verhuizing-kantoorinventaris.jpeg",
  "size": 350603,
  "content_type": "image/jpeg",
  "created_at": "2026-11-02T22:19:52Z"
}
